class PairItWith extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Set up Mutation Observer
    this.observer = new MutationObserver((mutations, observer) => {
      const productCard = document.querySelector(
        '.piw-PairItWith .prd-CardAlt_Async',
      )

      if (productCard) {
        if (this.classList.contains('sec-Section-hidden')) {
          this.classList.remove('sec-Section-hidden')
        }

        observer.disconnect() // Stop observing once the carousel is setup

        // Clear the timeout if productCard is found
        clearTimeout(this.timeoutId)
      }
    })

    // Observe body for changes
    this.observer.observe(document.body, { childList: true, subtree: true })

    // Set up a timeout to stop observing after 5 seconds if the node isn't found
    this.timeoutId = setTimeout(() => {
      this.observer.disconnect()
      this.remove()
    }, 3000)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    // Disconnect observer when the element is removed
    if (this.observer) {
      this.observer.disconnect()
    }

    // Clear the timeout when the element is removed
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }
}

if (!customElements.get('pair-it-with')) {
  customElements.define('pair-it-with', PairItWith)
}
